export function first_user_label(values = []) {
  return values.find(Boolean) || '';
}

export function group_filter_key(value = '') {
  return String(value || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '') || 'all';
}
